import { Link } from "react-router-dom";

const GUARANTEES = [
  {
    title: "Testé avant renvoi",
    desc: "Chaque calculateur est contrôlé sur banc après intervention. Il repart uniquement une fois le fonctionnement validé.",
  },
  {
    title: "Devis sous 2h ouvrées",
    desc: "Votre demande est traitée rapidement : vous recevez un chiffrage clair, sans surprise, avant tout engagement.",
  },
  {
    title: "Suivi postal France entière",
    desc: "Envoi et retour en express suivi 24h. Vous savez où est votre boîtier à chaque étape, de l'atelier à votre boîte aux lettres.",
  },
];

export const ProofFooter = () => (
  <>
    <section className="py-20 px-6 border-b border-[#1C2C4E] bg-[#06101F]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="font-mono text-xs uppercase tracking-widest text-slate-400 block mb-2">Nos engagements</span>
          <h2 className="font-display text-3xl uppercase tracking-tight text-white">Ce qui nous engage</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {GUARANTEES.map((g, i) => (
            <div key={g.title} className="p-6 rounded-lg bg-[#0F1D36] border border-[#1C2C4E]">
              <span className="font-mono text-xs text-[#51ADDA] block mb-3">0{i + 1}</span>
              <h3 className="font-display text-lg uppercase text-white mb-2">{g.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{g.desc}</p>
            </div>
          ))}
        </div>
        <p className="text-center font-mono text-xs uppercase tracking-widest text-slate-500 mt-10">
          Avis clients réels à venir — ils apparaîtront ici dès les premières interventions.
        </p>
      </div>
    </section>

    <footer className="py-12 px-6 bg-[#0A1628] text-slate-400 text-xs font-mono">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <span className="font-display text-white text-base tracking-wider uppercase">NEOELEC AUTO</span>
          <span className="text-slate-400">• Programmation calculateurs auto France</span>
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          <a href="mailto:bellahcen.youness@gmail.com" data-testid="footer-contact-link" className="text-[#51ADDA] hover:underline">bellahcen.youness@gmail.com</a>
          <a href="#devis" data-testid="footer-devis-link" className="text-[#51ADDA] hover:underline">Formulaire Devis</a>
          <Link to="/suivi" data-testid="footer-suivi-link" className="text-slate-400 hover:text-white transition-colors">Suivi demande</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="text-slate-400 hover:text-white transition-colors">Espace Pro</Link>
          <span>Paiement CB Sécurisé</span>
          <span>Expédition Colissimo / Chronopost</span>
        </div>
      </div>
    </footer>
  </>
);
